module.exports = __webpack_public_path__ + "img/41_Piuariu-Molnar_Deutsch-Walachische_Sprachlehre_Viena_1788_foaie_de_titlu.4e0af8c6.jpg";